import React from 'react';
import { buildActions } from './dashboardModel';
import './dashboard-ux.css';

const ICONS = {
  repriceUp: 'pi pi-arrow-up', reprice: 'pi pi-arrow-down', stockOut: 'pi pi-exclamation-triangle', noCompetitor: 'pi pi-users',
  newProduct: 'pi pi-star', mapViolation: 'pi pi-exclamation-triangle', mrpViolation: 'pi pi-exclamation-triangle',
  noMap: 'pi pi-question-circle', noReseller: 'pi pi-users', notSupplied: 'pi pi-times-circle', loss: 'pi pi-chart-line',
  variantMatching: 'pi pi-images', unauthorized: 'pi pi-user-minus',
};

const AttentionQueue = ({ profile, overview = {}, t }) => {
  const actions = buildActions(profile, overview);
  if (actions.length === 0) {
    return <div className="pux-empty">{t('dashboard.action.all_clear', 'Nothing needs attention right now.')}</div>;
  }
  return (
    <div className="dux-queue">
      {actions.map((a) => (
        <a key={a.key} className={`dux-action-card dux-action-card--${a.tone}`} href={a.route} target="_blank" rel="noopener noreferrer">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <i className={ICONS[a.key] || 'pi pi-circle'} style={{ fontSize: 20 }} />
            <i className="pi pi-arrow-right" style={{ fontSize: 15 }} />
          </div>
          <div className="dux-action-count">{a.count}</div>
          <div className="dux-action-label">{t('dashboard.action.' + a.key)}</div>
        </a>
      ))}
    </div>
  );
};

export default AttentionQueue;
